export const RULE_MESSAGE_TYPE = {
	INFO: 'Info',
	WARNING: 'Warning',
	ERROR: 'Error'
};

export const SELECTED_RULE_CLASS = {
	INFO: 'revised-rule-info',
	WARNING: 'revised-rule-warnig',
	ERROR: 'revised-rule-error'
};
